export default __webpack_public_path__ + "static/media/invoice.01d2cc67.svg";